import {NgModule} from '@angular/core';

import {EventGroupRoutingModule} from './event-group-routing.module';
import {EventGroupComponent} from './event-group.component';
import {SharedModule} from "@biletix/shared/shared.module";
import { EventGroupPageStateService } from './services/event-group-page-state.service';
import { EventGroupResolver } from './resolvers/event-group.resolver';
import {EventGroupListComponent} from './components/event-group-list/event-group-list.component';
import {ListItemComponent} from "@biletix/features/event-group/components/event-group-list/list-item/list-item.component";
import {EventPageTabMenuComponent} from "@biletix/features/event-group/components/event-group-list/event-page-tab-menu/event-page-tab-menu.component";

// export function eventHttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/event/', '.json');
// }

@NgModule({
    declarations: [
      EventGroupComponent,
      ListItemComponent,
      EventGroupListComponent,
      EventPageTabMenuComponent
    ],
  imports: [
    SharedModule,
    EventGroupRoutingModule,
  ],
  providers: [
    EventGroupResolver,
    EventGroupPageStateService
  ]
})
export class EventGroupModule {
}
